import Variation from "./Variation";
import BaseCard from "./BaseCard";

export default function MarqueeCard({ label, sublabel, value, variation, logo }) {
    return (
        <BaseCard classNames="cot-marquee-card">

            {logo && <img className="ticker-logo" src={logo} alt={label} width="32" height="32" />}

            <div className="text">
                <p className="paragraph label">{label}</p>
                <p className="small-text sublabel">{sublabel}</p>
            </div>

            <div className="value-variation">
                <p className="paragraph value">{value}</p>

                <Variation value={variation} />
            </div>
        </BaseCard>
    );
}
